const SHOW_ATTR = 'data-show-contact-footer';

// The embedding app owns visibility: it clears data-show-contact-footer on the
// element named by data-visibility-host while booting and sets it only on the
// routes that want the footer, so we keep following the attribute for as long
// as the page lives.
export function syncContactFooterVisibility(footer: HTMLElement): void {
  const hostId = footer.dataset.visibilityHost;
  if (!hostId) return;

  const host = document.getElementById(hostId);
  if (!host) return;

  const sync = () => {
    footer.style.display = host.hasAttribute(SHOW_ATTR) ? '' : 'none';
  };

  sync();
  new MutationObserver(sync).observe(host, {
    attributes: true,
    attributeFilter: [SHOW_ATTR],
  });
}
